<template>
  <v-menu
    v-model="menu"
    :close-on-content-click="false"
    transition="scale-transition"
    offset-y
    min-width="auto"
  >
    <template #activator="{ on, attrs }">
      <v-text-field
        v-model="dateFormatted"
        prepend-icon="mdi-calendar"
        readonly
        :rules="rules"
        v-bind="attrs"
        v-on="on"
      />
    </template>
    <v-date-picker
      v-model="newValue"
      :max="maxDate"
    />
  </v-menu>
</template>

<script>
import { watch, ref, computed } from '@vue/composition-api';
import { format } from 'date-fns';
import { formatDate } from '@/helpers/utils';

export default {
  props: {
    value: {
      type: String,
      default: null
    },
    rules: {
      type: Array,
      default () {
        return [];
      }
    },
    placeholder: {
      type: String,
      default: null
    }
  },
  setup (props, context) {
    const newValue = ref(props.value);
    const menu = ref(false);
    const dateFormatted = ref(formatDate(props.value, 'dd/MM/yyyy'));

    const maxDate = computed(() => format(new Date(), 'yyyy-MM-dd'));

    // v-model
    watch(newValue, () => {
      context.emit('input', newValue.value);
    });

    watch(() => props.value, () => {
      newValue.value = props.value;
      dateFormatted.value = formatDate(props.value, 'dd/MM/yyyy');
    });

    return { newValue, menu, dateFormatted, maxDate };
  }
};
</script>
